export const projectKeys = {
    all: ['projects'],
    list: (params) => ['projects', 'list', params],
    detail: (id) => ['projects', 'detail', id],
    plans: (projectId) => ['plans', 'list', { project_id: projectId }],
};
